import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import { clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,
    events: [],
    loadingEvents: false,
};
const route = 'modules/driverPerformance/views/driver/modals/advancedFilters/redux/slice';

export const getDriverPerformanceDriverSearchEvents = createAsyncThunk('driverPerformance/driver/advancedFilters/searchEvents', async (payload, { rejectWithValue, getState }) => {
    try {

        const response = await clientQuery(`
            query ($conditions: [EventSearchInput], $sort: [EventSortInput], $limit: Int, $offset: Int) {
                data: searchEvents(
                    conditions: $conditions
                    sort: $sort
                    limit: $limit
                    offset: $offset
                ) {
                    total
                    items {
                        id
                        eventName
                        diagnostic
                        color
                        type
                        category
                    }
                }
            }
        `,
            {
                conditions: [
                    {
                        fields: "type",
                        terms: ["risk"],
                        exact: true,
                    }
                ],
                sort: [
                    {
                        field: "eventName",
                        order: "ASC",
                    },
                ],
                limit: 1000,
                offset: 0,
            },
            endpoints.GRAPHQL_GENERAL_V2
        );

        return response?.data?.items.length ? response?.data?.items.map((item) => ({ id: item?.eventName, name: item?.eventName })) :  [];

    } catch (exc) {
        ExceptionManager(exc, route, 'searchEvents');
        return rejectWithValue(exc);
    }
});

//Slice
const DriverPerformanceDriverTabAdvancedFiltersRedux = createSlice({
    name: "driverPerformance/driver/advancedFilters",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
        openModalAdvancedFilters: (state, action) => {
            state.open = action.payload.open;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        builder.addCase(getDriverPerformanceDriverSearchEvents.pending, (state) => {
            state.loadingEvents = true;
            state.error = null;
        });
        builder.addCase(getDriverPerformanceDriverSearchEvents.fulfilled, (state, action) => {
            state.loadingEvents = false;
            state.events = action.payload;
        });
        builder.addCase(getDriverPerformanceDriverSearchEvents.rejected, (state, action) => {
            state.loadingEvents = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = DriverPerformanceDriverTabAdvancedFiltersRedux;

// Extract and export each action creator by name
export const { openModalAdvancedFilters, reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
